import { QueryKey } from "@tanstack/react-query";

export const bootstrapQueryKeys = {
  all: () => ['bootstrapServerRoutes'] as QueryKey,
  listByBrand: (filters: Readonly<{ [k: string]: any }>) => [...bootstrapQueryKeys.all(), { filters }] as QueryKey,
};
